import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const FILING_BATCH_INFO_HELP: HelpContent[] = [
    {
        helpContentId: 'filing-batch-info.panel',
        tooltipText: 'Info that is shared by all filings in the batch.',
        hasIcon: true
    },
];

export const CHANGE_DETECTION_PRIOR_RETURN_HELP: string =
    'Uses last year return to detect changes such as additions ' +
    '(acquisitions, transfers in, cost increases) and deductions (disposals, transfers out, cost decreases).';

export const CHANGE_DETECTION_COMPANY_ASSET_LIST_HELP: string =
    'Uses the company asset list to detect changes such as deductions (disposals, transfers out). ' +
    'Typically used for first-year preparation when there is no prior return.';
